export default __webpack_public_path__ + "static/media/2412303.682e8ec0.webp";